import { ApplicationConfig, importProvidersFrom, mergeApplicationConfig } from '@angular/core';
import { HammerModule } from '@angular/platform-browser';
import { provideRmaInstance } from '@rma/generic/ng/instance';
import { provideDeviceIdentification } from '@rma/generic/ng/util';
import { provideRmaFeatureFlagsBrowser } from '@rma/generic/ng/feature-flags';
import { Environment, IS_PRODUCTION, provideRmaEnvironment } from '@rma/public/generic/util/environment';
import { FeatureFlagUserIdentificationService } from '@rma/public/generic/util/feature-flags';
import { provideRmaMetaPixelRouteTracking } from '@rma/public/generic/util/tracking/meta-pixel';
import { environment as devEnvironment } from '../environment/environment';
import { commonConfig } from './app.config.common';

declare let environment: Environment;

const env = IS_PRODUCTION ? environment : devEnvironment;

const browserConfig: ApplicationConfig = {
  providers: [
    provideRmaInstance(env.tenantCode, env.type),
    // We can't add this in the app because it breaks ssr
    importProvidersFrom(HammerModule),
    // this overrides the one that is injected from ssr, so we need to make sure it is done only in the browser version
    provideRmaEnvironment(env),
    provideRmaFeatureFlagsBrowser(env.launchDarklyClientId, FeatureFlagUserIdentificationService),
    // This is cookie based, so it can't be loaded on the server
    provideDeviceIdentification(),
    provideRmaMetaPixelRouteTracking(),
  ],
};

export const config = mergeApplicationConfig(commonConfig, browserConfig);
